import { render, staticRenderFns } from "./AlertIgnoreModal.vue?vue&type=template&id=e432e612&scoped=true&"
import script from "./AlertIgnoreModal.vue?vue&type=script&lang=ts&"
export * from "./AlertIgnoreModal.vue?vue&type=script&lang=ts&"
import style0 from "./AlertIgnoreModal.vue?vue&type=style&index=0&id=e432e612&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e432e612",
  null
  
)

export default component.exports